var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJungleActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.078 0s8.57 8.931 5.13 16c0 0-2.414-3.123-5.31-4.548 0 0 .482-4.22-2.898-7.014 0 0 4.587 1.973 5.553 5.041 0 0 1.086-4.383-2.475-9.479zM16 4s-3.44 3.068-2.837 6.85c0 0-2.414 1.424-2.836 2.3 0 0 .241-6.63 5.673-9.15zm-3.393-4s-2.656 4.603-2.414 8c0 0-.543.767-.725 1.425 0 0-.663-2.52-1.207-3.124l.016-.03c.202-.386 2.32-4.395 4.33-6.271z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/roles/jungle-active.svg";
export { SvgJungleActive as ReactComponent };